import httpUserClient from '@/plugins/httpUserClient';

export default {
  getReserves(id) {
    return httpUserClient.get(`user/meeting/appointments/${id}`);
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/userApis/meeting/reservesApis.js